import ad_banner from 'assets/img/ad-banner.avif';
import ad from 'assets/img/ad.avif';
import ad2 from 'assets/img/ad2.gif';
import bg2 from 'assets/img/bg2.jpg';
import splash from 'assets/img/splash.jpg';
import poster_opt from 'assets/img/poster_opt.png';
import poster_opt2 from 'assets/img/poster_opt2.webp';
import cute_cat from 'assets/img/cute-cat.png';
import cute_cat_ear from 'assets/img/cute-cat-ear.png';
import version_upload_bg from 'assets/img/version-update-bg.png';

import alipay_logo from 'assets/img/alipay-logo.svg';
import alipay_zhi from 'assets/img/alipay-zhi.svg';
import wechatpay_logo from 'assets/img/wechatpay-logo.svg';
import favicon from 'assets/img/favicon.svg';
// import uutt from "assets/img/logo/uutt.png";
// import uutt_round from "assets/img/logo/uutt_round.png";
// import uutt_round_mini from "assets/img/logo/uutt_round_mini.png";
import avatar from 'assets/img/avatar.avif';
import cuteAvatar from 'assets/img/cute_avatar.avif';
import banner from 'assets/img/banner.avif';
import cate from 'assets/img/cate.jpg';
import login_slogan from 'assets/img/login-slogan.jpg';
import logo from 'assets/img/logo.png';
import vip from 'assets/img/vip.jpg';
import qrcodeUUTT from 'assets/img/qrcode_uutt.png';

import loadingImg from 'assets/img/loading-img_opt.avif';
import fallbackImg from 'assets/img/fallback-Img.avif';
import fallbackVerticalImg from 'assets/img/fallback-img-vertical.avif';
import darkwebTipImg from 'assets/img/darkweb_tip.avif';
import darkwebVipBuyImg from 'assets/img/darkweb_vip_buy.avif';
import loginCredentialsBg from 'assets/img/login_credentials_bg.avif';
import userBannerBg from 'assets/img/user-banner-bg.avif';
import sesamaTop from 'assets/img/sesama_top.avif';
import sesamaTop2 from 'assets/img/sesama_top2.avif';
import touhouLoading from 'assets/img/touhou-loading.gif';

// 分类封面
import cate01_1 from 'assets/img/icons/cate/01最新uu/1.jpg';
import cate01_2 from 'assets/img/icons/cate/01最新uu/2.jpg';
import cate01_3 from 'assets/img/icons/cate/01最新uu/3.jpg';
import cate01_4 from 'assets/img/icons/cate/01最新uu/4.jpg';
import cate01_5 from 'assets/img/icons/cate/01最新uu/5.jpg';

import cate02_1 from 'assets/img/icons/cate/02经典uu/1.jpg';
import cate02_2 from 'assets/img/icons/cate/02经典uu/2.jpg';
import cate02_3 from 'assets/img/icons/cate/02经典uu/3.jpg';
import cate02_4 from 'assets/img/icons/cate/02经典uu/4.jpg';
import cate02_5 from 'assets/img/icons/cate/02经典uu/5.jpg';

import cate03_1 from 'assets/img/icons/cate/03优质国产/1.jpg';
import cate03_2 from 'assets/img/icons/cate/03优质国产/2.jpg';
import cate03_3 from 'assets/img/icons/cate/03优质国产/3.jpg';
import cate03_4 from 'assets/img/icons/cate/03优质国产/4.jpg';
import cate03_5 from 'assets/img/icons/cate/03优质国产/5.jpg';

import cate04_1 from 'assets/img/icons/cate/04强奸迷奸/1.jpg';
import cate04_2 from 'assets/img/icons/cate/04强奸迷奸/2.jpg';
import cate04_3 from 'assets/img/icons/cate/04强奸迷奸/3.jpg';
import cate04_4 from 'assets/img/icons/cate/04强奸迷奸/4.jpg';
import cate04_5 from 'assets/img/icons/cate/04强奸迷奸/5.jpg';

import cate05_1 from 'assets/img/icons/cate/05另类稀缺/1.jpg';
import cate05_2 from 'assets/img/icons/cate/05另类稀缺/2.jpg';
import cate05_3 from 'assets/img/icons/cate/05另类稀缺/3.jpg';
import cate05_4 from 'assets/img/icons/cate/05另类稀缺/4.jpg';
import cate05_5 from 'assets/img/icons/cate/05另类稀缺/5.jpg';

import cate06_1 from 'assets/img/icons/cate/06AI明星/1.jpg';
import cate06_2 from 'assets/img/icons/cate/06AI明星/2.jpg';
import cate06_3 from 'assets/img/icons/cate/06AI明星/3.jpg';
import cate06_4 from 'assets/img/icons/cate/06AI明星/4.jpg';
import cate06_5 from 'assets/img/icons/cate/06AI明星/5.jpg';

import cate07_1 from 'assets/img/icons/cate/07人兽性交/1.jpg';
import cate07_2 from 'assets/img/icons/cate/07人兽性交/2.jpg';
import cate07_3 from 'assets/img/icons/cate/07人兽性交/3.jpg';
import cate07_4 from 'assets/img/icons/cate/07人兽性交/4.jpg';
import cate07_5 from 'assets/img/icons/cate/07人兽性交/5.jpg';

import cate08_1 from 'assets/img/icons/cate/08家庭乱伦/1.jpg';
import cate08_2 from 'assets/img/icons/cate/08家庭乱伦/2.jpg';
import cate08_3 from 'assets/img/icons/cate/08家庭乱伦/3.jpg';
import cate08_4 from 'assets/img/icons/cate/08家庭乱伦/4.jpg';
import cate08_5 from 'assets/img/icons/cate/08家庭乱伦/5.jpg';

// 专辑封面
import album01_1 from 'assets/img/icons/album/01/1.jpg';
import album01_2 from 'assets/img/icons/album/01/2.jpg';
import album01_3 from 'assets/img/icons/album/01/3.jpg';
import album01_4 from 'assets/img/icons/album/01/4.jpg';
import album01_5 from 'assets/img/icons/album/01/5.jpg';

import album02_1 from 'assets/img/icons/album/02/1.jpg';
import album02_2 from 'assets/img/icons/album/02/2.jpg';
import album02_3 from 'assets/img/icons/album/02/3.jpg';
import album02_4 from 'assets/img/icons/album/02/4.jpg';
import album02_5 from 'assets/img/icons/album/02/5.jpg';

import album03_1 from 'assets/img/icons/album/03/1.jpg';
import album03_2 from 'assets/img/icons/album/03/2.jpg';
import album03_3 from 'assets/img/icons/album/03/3.jpg';
import album03_4 from 'assets/img/icons/album/03/4.jpg';
import album03_5 from 'assets/img/icons/album/03/5.jpg';

import album04_1 from 'assets/img/icons/album/04/1.jpg';
import album04_2 from 'assets/img/icons/album/04/2.jpg';
import album04_3 from 'assets/img/icons/album/04/3.jpg';
import album04_4 from 'assets/img/icons/album/04/4.jpg';
import album04_5 from 'assets/img/icons/album/04/5.jpg';

import album05_1 from 'assets/img/icons/album/05/1.jpg';
import album05_2 from 'assets/img/icons/album/05/2.jpg';
import album05_3 from 'assets/img/icons/album/05/3.jpg';
import album05_4 from 'assets/img/icons/album/05/4.jpg';
import album05_5 from 'assets/img/icons/album/05/5.jpg';

import album06_1 from 'assets/img/icons/album/06/1.jpg';
import album06_2 from 'assets/img/icons/album/06/2.jpg';
import album06_3 from 'assets/img/icons/album/06/3.jpg';
import album06_4 from 'assets/img/icons/album/06/4.jpg';
import album06_5 from 'assets/img/icons/album/06/5.jpg';

import album07_1 from 'assets/img/icons/album/07/1.jpg';
import album07_2 from 'assets/img/icons/album/07/2.jpg';
import album07_3 from 'assets/img/icons/album/07/3.jpg';
import album07_4 from 'assets/img/icons/album/07/4.jpg';
import album07_5 from 'assets/img/icons/album/07/5.jpg';

import album08_1 from 'assets/img/icons/album/08/1.jpg';
import album08_2 from 'assets/img/icons/album/08/2.jpg';
import album08_3 from 'assets/img/icons/album/08/3.jpg';
import album08_4 from 'assets/img/icons/album/08/4.jpg';
import album08_5 from 'assets/img/icons/album/08/5.jpg';

import album09_1 from 'assets/img/icons/album/09/1.jpg';
import album09_2 from 'assets/img/icons/album/09/2.jpg';
import album09_3 from 'assets/img/icons/album/09/3.jpg';
import album09_4 from 'assets/img/icons/album/09/4.jpg';
import album09_5 from 'assets/img/icons/album/09/5.jpg';

export default {
  favicon,
  cute_cat,
  cute_cat_ear,
  version_upload_bg,
  // uutt,
  // uutt_round,
  // uutt_round_mini,
  avatar,
  cuteAvatar,
  banner,
  logo,
  login_slogan,
  cate,
  vip,
  qrcodeUUTT,
  ad,
  ad2,
  bg2,
  splash,
  poster_opt,
  poster_opt2,
  ad_banner,
  alipay_logo,
  alipay_zhi,
  wechatpay_logo,
  fallbackImg,
  fallbackVerticalImg,
  loadingImg,
  darkwebTipImg,
  darkwebVipBuyImg,
  loginCredentialsBg,
  sesamaTop,
  sesamaTop2,
  touhouLoading,
  cateCover: [
    [cate01_1, cate01_2, cate01_3, cate01_4, cate01_5],
    [cate02_1, cate02_2, cate02_3, cate02_4, cate02_5],
    [cate03_1, cate03_2, cate03_3, cate03_4, cate03_5],
    [cate04_1, cate04_2, cate04_3, cate04_4, cate04_5],
    [cate05_1, cate05_2, cate05_3, cate05_4, cate05_5],
    [cate06_1, cate06_2, cate06_3, cate06_4, cate06_5],
    [cate07_1, cate07_2, cate07_3, cate07_4, cate07_5],
    [cate08_1, cate08_2, cate08_3, cate08_4, cate08_5],
  ],
  albumCover: [
    [album01_1, album01_2, album01_3, album01_4, album01_5],
    [album02_1, album02_2, album02_3, album02_4, album02_5],
    [album03_1, album03_2, album03_3, album03_4, album03_5],
    [album04_1, album04_2, album04_3, album04_4, album04_5],
    [album05_1, album05_2, album05_3, album05_4, album05_5],
    [album06_1, album06_2, album06_3, album06_4, album06_5],
    [album07_1, album07_2, album07_3, album07_4, album07_5],
    [album08_1, album08_2, album08_3, album08_4, album08_5],
    [album09_1, album09_2, album09_3, album09_4, album09_5],
  ],
};
